import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Order from "./Order";
import Orders from "./Orders";
import Title from "../Titel";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const OrdersTab = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const OrderId = searchParams.get('order');
    const code = searchParams.get('code');

    const [onOrder, setOnOrder] = useState(OrderId ? { id: OrderId } : undefined)


    const handleSearch = async event => {
        event.preventDefault()
        const value = event.target[0].value
        const newParams = new URLSearchParams(searchParams);
        newParams.set('code', value);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
    }

    return (
        <>
            {!!onOrder ? <Order setOnOrder={setOnOrder} /> :
                <div className="w-full flex flex-col p-4">
                    <Title title='سفارشات' className='md:text-lg mb-3' />
                    <div className="flex flex-col gap-4">
                        <form className='relative md:w-1/4 w-44' onSubmit={handleSearch}>
                            <div className='rounded border border-gray-400 pr-1 centerOfParent pl-8 w-full'>
                                <input className='appearance-none w-full h-full px-2 py-1.5 outline-none focus:outline-none border-0' type="text" placeholder='کد سفارش' />
                            </div>
                            <button className='centerOfParent bg-white outline-none focus:outline-none border-0 absolute left-2 top-1/2 -translate-y-1/2'>
                                <svg className="fill-gray-400" stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"></path></svg></button>
                        </form>
                        {!!code ? <Orders setOnOrder={setOnOrder} /> : <Tabs aria-label="Options" className="border-b pb-3">
                            <Tab key="1" title="در انتظار پرداخت">
                                <Card className="!shadow-none rounded-none">
                                    <CardBody>
                                        <Orders setOnOrder={setOnOrder} status='1' />
                                    </CardBody>
                                </Card>
                            </Tab>
                            <Tab key="2" title="در حال اماده سازی" >
                                <Card className="!shadow-none rounded-none">
                                    <CardBody>
                                        <Orders setOnOrder={setOnOrder} status='2' />
                                    </CardBody>
                                </Card>
                            </Tab>
                            <Tab key="3" title="ارسال شده" >
                                <Card className="!shadow-none rounded-none">
                                    <CardBody>
                                        <Orders setOnOrder={setOnOrder} status='3' />
                                    </CardBody>
                                </Card>
                            </Tab>
                            <Tab key="4" title="تحویل داده شده">
                                <Card className="!shadow-none rounded-none">
                                    <CardBody>
                                        <Orders setOnOrder={setOnOrder} status='4' />
                                    </CardBody>
                                </Card>
                            </Tab>
                            <Tab key="5" title="لغو شده">
                                <Card className="!shadow-none rounded-none">
                                    <CardBody>
                                        <Orders setOnOrder={setOnOrder} status='5' />
                                    </CardBody>
                                </Card>
                            </Tab>
                        </Tabs>}
                    </div>
                </div>}
        </>
    );
};

export default OrdersTab;